// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-matches-admin__container {
    display: flex;
    border: 10px solid var(--new-background-color);
    border-radius: 8px;
}

.tournament-matches-admin__board {
    width: 80%;
    padding: 16px 19px;
    border-right: 10px solid var(--new-background-color);
}

.tournament-matches-admin__board__btns-add {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-matches-admin__board__btns-add__btns {
    display: flex;
    gap: 12px;
    align-items: center;
}

.tournament-matches-admin__actions {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 8px;
    width: 20%;
}

.tournament-matches-admin__actions .button {
    width: 100%;
    grid-template-columns: initial;
    grid-template-areas: initial;
    padding: 12px;
}

.tournament-matches-admin__board__btns-add__btns .button {
    display: flex;
    gap: var(--space);
    align-items: center;
    padding: 12px;
}

.tournament-matches-admin__export-excel.secondary-button:active,
.tournament-matches-admin__export-excel.secondary-button:focus {
    background-color: unset;
    color: unset;
}

.tournament-matches-admin__board__input-search {
    display: flex;
    align-items: center;
}

.tournament-matches-admin__board__input-search input {
    min-width: calc(var(--space-x3) * 8);
    border: 1px solid var( --new-gray-background-color);
    min-height: var( --space-x3 );
    border-radius: 4px;
    background: var( --new-background-color );
    padding-left: var( --space-x3 );
}

.tournament-matches-admin__board__input-search .icon-search {
    position: absolute;
    font-size: calc( var( --space ) + var( --space-quarter ) );
    color: #949F9A;
    margin-left: calc( var( --space ) - var( --space-eighth ) );
}

.tournament-matches-admin__board__input-search__btn-calendar {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tournament-matches-admin__board__input-search__btn-calendar .button {
    display: flex;
    gap: var(--space);
    align-items: center;
    border: 1px solid var(--new-line-color);
    color: var(--primary-very-dark-color);
}

.tournament-matches-admin__board__filters {
    margin-top: 12px;
    margin-bottom: 24px;
}

.tournament-matches-admin__groups {
    margin-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-matches-admin/TournamentMatchesAdminComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,mDAAmD;IACnD,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;IACd,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".tournament-matches-admin__container {\n    display: flex;\n    border: 10px solid var(--new-background-color);\n    border-radius: 8px;\n}\n\n.tournament-matches-admin__board {\n    width: 80%;\n    padding: 16px 19px;\n    border-right: 10px solid var(--new-background-color);\n}\n\n.tournament-matches-admin__board__btns-add {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-matches-admin__board__btns-add__btns {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n}\n\n.tournament-matches-admin__actions {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px 8px;\n    width: 20%;\n}\n\n.tournament-matches-admin__actions .button {\n    width: 100%;\n    grid-template-columns: initial;\n    grid-template-areas: initial;\n    padding: 12px;\n}\n\n.tournament-matches-admin__board__btns-add__btns .button {\n    display: flex;\n    gap: var(--space);\n    align-items: center;\n    padding: 12px;\n}\n\n.tournament-matches-admin__export-excel.secondary-button:active,\n.tournament-matches-admin__export-excel.secondary-button:focus {\n    background-color: unset;\n    color: unset;\n}\n\n.tournament-matches-admin__board__input-search {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-matches-admin__board__input-search input {\n    min-width: calc(var(--space-x3) * 8);\n    border: 1px solid var( --new-gray-background-color);\n    min-height: var( --space-x3 );\n    border-radius: 4px;\n    background: var( --new-background-color );\n    padding-left: var( --space-x3 );\n}\n\n.tournament-matches-admin__board__input-search .icon-search {\n    position: absolute;\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    color: #949F9A;\n    margin-left: calc( var( --space ) - var( --space-eighth ) );\n}\n\n.tournament-matches-admin__board__input-search__btn-calendar {\n    margin-top: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.tournament-matches-admin__board__input-search__btn-calendar .button {\n    display: flex;\n    gap: var(--space);\n    align-items: center;\n    border: 1px solid var(--new-line-color);\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-matches-admin__board__filters {\n    margin-top: 12px;\n    margin-bottom: 24px;\n}\n\n.tournament-matches-admin__groups {\n    margin-top: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
